<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="12.734" height="7.475" viewBox="0 0 12.734 7.475">
        <path id="Caminho_58" data-name="Caminho 58"
            d="M2694.315,1327.13a.684.684,0,0,0-.5.218l-5.686,6.115a.68.68,0,0,0,1,.925l5.188-5.578,5.189,5.578a.68.68,0,1,0,1-.925l-5.687-6.115A.682.682,0,0,0,2694.315,1327.13Z"
            transform="translate(-2687.948 -1327.13)" fill="#f58634" />
    </svg>
</template>